import React from 'react';
// import errorImg from '../assets/images/error_404.png';
import { Link } from 'react-router-dom';

export default function NotFound() {
	return (
		<React.Fragment>
			<div className='error_content'>
				<h1>404</h1>
				<h2>PAGE NOT FOUND</h2>
				<p>Sorry! The page you're looking for does not seem to exits.
				</p>
				<button><Link to='/'>Go To Home Page</Link></button>
			</div>
		</React.Fragment>
	);
}
